import {Directive, ElementRef, HostListener, OnInit} from '@angular/core';

@Directive({
  selector: '[dragScroll]',
  standalone:true
})
export class DragScrollDirective {

  constructor(private ele: ElementRef) {

    // document.addEventListener('DOMContentLoaded', function () {

      // @ts-ignore
      ele.nativeElement.style.cursor = 'grab';
      ele.nativeElement.style.userSelect = 'none';

      let pos = { top: 0, left: 0, x: 0, y: 0 };

      const mouseDownHandler = function (e) {

        // @ts-ignore
        ele.nativeElement.style.cursor = 'grabbing';
        // @ts-ignore
        ele.nativeElement.style.userSele = 'none';


        pos = {
          // @ts-ignore
          left: ele.nativeElement.scrollLeft,
          // @ts-ignore
          top: ele.nativeElement.scrollTop,
          // Get the current mouse position
          x: e.clientX,
          y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
      };

      const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the ele.nativeElementment
        // @ts-ignore
        ele.nativeElement.scrollTop = pos.top - dy;
        // @ts-ignore
        ele.nativeElement.scrollLeft = pos.left - dx;
      };

      const mouseUpHandler = function () {
        // @ts-ignore
        ele.nativeElement.style.cursor = 'grab';
        // @ts-ignore
        ele.nativeElement.style.removeProperty('user-sele');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      // Attach the handler
      // @ts-ignore
      ele.nativeElement.addEventListener('mousedown', mouseDownHandler);
    // });

  }
  // @HostListener('mousedown') onMouseEnter() {
  //   this.ele.style.cursor = 'grabbing';
  //   ele.style.userSelect = 'none';
  //
  //   let pos = {
  //     left: ele.scrollLeft,
  //     top: ele.scrollTop,
  //     // Get the current mouse position
  //     x: e.clientX,
  //     y: e.clientY,
  //   };
  // }
  //
  // @HostListener('mousemove') onMouseLeave() {
  //   this.highlight('');
  // }
  // @HostListener('mouseup') onMouseLeave() {
  //   this.highlight('');
  // }

}
